import { Link } from 'react-router';

import { GlassSurface } from '@components/glass/GlassSurface';
import { Logo } from '@components/ui/Logo';
import { NAV_ITEMS, SITE } from '@config/site';
import { SERVICES } from '@config/services';

import styles from './SiteFooter.module.scss';

/**
 * Site footer. A large surface that rarely has anything interesting behind
 * it, so it keeps frost but skips refraction (`refract={false}`): the rim
 * effect would cost a full backdrop pass to bend a plain background.
 */
export const SiteFooter = () => (
  <footer className={styles.footer}>
    <GlassSurface variant="regular" refract={false} className={styles.panel}>
      <div className={styles.brand}>
        <Logo />
        <p className={styles.blurb}>{SITE.description}</p>
        <a className={styles.email} href={`mailto:${SITE.email}`}>
          {SITE.email}
        </a>
      </div>

      <nav aria-label="Footer" className={styles.columns}>
        <div>
          <h2 className={styles.heading}>Company</h2>
          <ul role="list" className={styles.list}>
            {NAV_ITEMS.map((item) => (
              <li key={item.to}>
                <Link to={item.to} viewTransition>
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className={styles.heading}>Services</h2>
          <ul role="list" className={styles.list}>
            {SERVICES.map((service) => (
              <li key={service.id}>
                <Link to={`/services#${service.id}`} viewTransition>
                  {service.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      <p className={styles.legal}>
        © {new Date().getFullYear()} {SITE.name}. All rights reserved.
      </p>
    </GlassSurface>
  </footer>
);
